export default __webpack_public_path__ + "static/starclub-journal-3637e692b47494c1c0dffecaa9e5d3d4.jpg";